import React from 'react';

import Image from 'src/components/atoms/image';

import PreviewVideoPlayer from '@components/share/media/previewVideoPlayer';
import { CourseHeaderBannerHighlightCoverStyle } from '@components/templates/courseDetail/courseAcademicBanner/header/highlightCover/style';
import CourseHeaderBannerHighlightCoverSkeleton from '@components/templates/courseDetail/courseRegularBanner/header/highlightCover/skeleton';
import { getAssetUrl } from '@helpers/utils';
import useCourseDetail from '@hooks/course/useCourseDetail';
import { CourseEntity } from '@redux/course/type/courseDetailType';

type CourseHeaderBannerHighlightCoverProps = {
  courseDetailSeo: CourseEntity;
};

const CourseHeaderBannerHighlightCover = ({ courseDetailSeo }: CourseHeaderBannerHighlightCoverProps) => {
  const { idName } = courseDetailSeo;
  const {
    highlightImage2xUrl,
    useVideoPreviewCourseBanner,
    videoPreviewUrl,
    videoPreviewSubtitles,
    isCourseDetailLoading,
  } = useCourseDetail();

  const DEFAULT_COURSE_CARD = getAssetUrl('thumbnail-course-card.jpg');

  if (isCourseDetailLoading) {
    return <CourseHeaderBannerHighlightCoverSkeleton />;
  }
  return (
    <CourseHeaderBannerHighlightCoverStyle>
      {useVideoPreviewCourseBanner ? (
        <PreviewVideoPlayer
          thumbUrl={highlightImage2xUrl}
          videoUrl={videoPreviewUrl!}
          subtitles={videoPreviewSubtitles || []}
          className="banner-preview-video-player"
        />
      ) : (
        <Image
          src={highlightImage2xUrl || DEFAULT_COURSE_CARD}
          alt={idName}
          errorImage={DEFAULT_COURSE_CARD}
          style={{ borderRadius: '8px' }}
        />
      )}
    </CourseHeaderBannerHighlightCoverStyle>
  );
};

export default CourseHeaderBannerHighlightCover;
